var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChartLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 5.375c0-.619-.506-1.125-1.125-1.125S2 4.756 2 5.375v24.75a5.623 5.623 0 005.625 5.625h29.25c.619 0 1.125-.506 1.125-1.125s-.506-1.125-1.125-1.125H7.625a3.376 3.376 0 01-3.375-3.375V5.375zm31.17 7.544a1.129 1.129 0 000-1.588 1.129 1.129 0 00-1.59 0l-9.33 9.33-5.956-5.956a1.129 1.129 0 00-1.588 0L9.08 22.582a1.129 1.129 0 000 1.588 1.129 1.129 0 001.59 0l7.08-7.08 5.956 5.956a1.129 1.129 0 001.588 0L35.42 12.918z"
  })));
}

export default SvgChartLine;